import { FC } from 'react'
import BaseButton from 'shared/components/button/components/base-button'
import { ButtonProps } from 'shared/components/button/types/button-interface'

interface ChipProps extends ButtonProps {
  selected: boolean
}

const Chip: FC<ChipProps> = ({ selected, className, ...buttonProps }) => (
  <BaseButton
    color={selected ? 'text-brand-primary' : 'text-text-primary'}
    hoverColor={selected ? 'hover:text-brand-primary' : 'hover:text-text-primary'}
    backgroundColor={selected ? 'bg-brand-primary/10' : 'bg-background-secondary'}
    hoverBackgroundColor={selected ? 'bg-brand-primary/20' : 'hover:bg-background-secondary'}
    borderColor={selected ? 'border-brand-primary' : 'border-text-secondary/30'}
    hoverBorderColor={'border-brand-primary'}
    type={'button'}
    className={className + ` w-full ${selected && 'font-bold'} `}
    {...buttonProps}
  />
)

export default Chip
